import { useCallback, useState } from "react"
import axiosInstance from "../../../../services/axios-client"
import { toast } from "react-toastify"
import useListGroupBu from "../../groupBu/ListGroupBusinessUnit/useListGroupBu"
import { useNavigate } from "react-router-dom"

const useBuForm = () => {
    const { getListGroupBu } = useListGroupBu()
    const navigate = useNavigate()
    const status = [{ 'label': 'Active', 'value': true }, { 'label': 'Inactive', 'value': false }]
    const [groupBu, setGroupBu] = useState([])
    const [isSaving, setIsSaving] = useState(false)
    const [payload, setPayload] = useState({
        ID: '',
        Status: undefined,
        Name: '',
        Pillar: '',
        GroupBusinessUnitId: undefined
    })

    const handleSelect = useCallback((value) => {
        setPayload((prev) => ({
            ...prev,
            GroupBusinessUnitId: value
        }))
    }, [])

    const handleSelectStatus = useCallback((value) => {
        setPayload((prev) => ({
            ...prev,
            Status: value
        }))
    }, [])

    const onChangeHandler = useCallback((e) => {
        const { name, value } = e.target
        setPayload((prev) => ({ ...prev, [name]: value }))
    }, [])

    const setListGroupBu = useCallback(async () => {
        const data = await getListGroupBu()
        const mappedGroupBu = []
        for (const gbu of data) {
            mappedGroupBu.push({
                label: gbu.GroupName,
                value: gbu.ID
            })
        }
        setGroupBu(mappedGroupBu)
    }, [getListGroupBu])

    const postBuForm = useCallback(async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            let res = await axiosInstance.post('/auth/business-units', payload)
            if (res.status === 200) {
                navigate('/bu-management/2')
                toast.success("Success Create Business Unit")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }
    }, [navigate, payload])

    const putBuForm = useCallback(async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            let res = await axiosInstance.put('/auth/business-units', payload)
            if (res.status === 200) {
                navigate('/bu-management/2')
                toast.success("Success Update Business Unit")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }
    }, [navigate, payload])

    const getBuForm = useCallback(async (id) => {
        try {
            let res = await axiosInstance.get(`/auth/business-units/${id}`)
            if (res.status === 200) {
                setPayload(res.data.data)
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }, [])

    return {
        payload,
        postBuForm,
        putBuForm,
        onChangeHandler,
        getBuForm,
        setListGroupBu,
        groupBu,
        handleSelect,
        handleSelectStatus,
        isSaving,
        status
    }
}

export default useBuForm